/**
 * @fileoverview gRPC-Web generated client stub for com.kipp.miraibarai.grpc.ops.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v5.29.3
// source: miraibaraiops/graphql_proxy_api.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as miraibaraiops_graphql_proxy_api_pb from '../miraibaraiops/graphql_proxy_api_pb'; // proto import: "miraibaraiops/graphql_proxy_api.proto"


export class GraphQLProxyAPIClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorRunQuery = new grpcWeb.MethodDescriptor(
    '/com.kipp.miraibarai.grpc.ops.v1.GraphQLProxyAPI/RunQuery',
    grpcWeb.MethodType.UNARY,
    miraibaraiops_graphql_proxy_api_pb.RunQueryRequest,
    miraibaraiops_graphql_proxy_api_pb.RunQueryResponse,
    (request: miraibaraiops_graphql_proxy_api_pb.RunQueryRequest) => {
      return request.serializeBinary();
    },
    miraibaraiops_graphql_proxy_api_pb.RunQueryResponse.deserializeBinary
  );

  runQuery(
    request: miraibaraiops_graphql_proxy_api_pb.RunQueryRequest,
    metadata?: grpcWeb.Metadata | null): Promise<miraibaraiops_graphql_proxy_api_pb.RunQueryResponse>;

  runQuery(
    request: miraibaraiops_graphql_proxy_api_pb.RunQueryRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: miraibaraiops_graphql_proxy_api_pb.RunQueryResponse) => void): grpcWeb.ClientReadableStream<miraibaraiops_graphql_proxy_api_pb.RunQueryResponse>;

  runQuery(
    request: miraibaraiops_graphql_proxy_api_pb.RunQueryRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: miraibaraiops_graphql_proxy_api_pb.RunQueryResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/com.kipp.miraibarai.grpc.ops.v1.GraphQLProxyAPI/RunQuery',
        request,
        metadata || {},
        this.methodDescriptorRunQuery,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/com.kipp.miraibarai.grpc.ops.v1.GraphQLProxyAPI/RunQuery',
    request,
    metadata || {},
    this.methodDescriptorRunQuery);
  }

}

